var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "container-form-ui",
      attrs: { id: "container-external-api" }
    },
    [
      _c("h3", { staticClass: "modal-title" }, [
        _vm._v(" " + _vm._s(_vm.fieldDetail ? "EDIT FIELD" : "ADD FIELD") + " ")
      ]),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { md: _vm.isHaveConfig ? "6" : "12" } },
            [
              _c("h4", [_vm._v("Properties")]),
              _vm._v(" "),
              _c(
                "b-form",
                { class: { "error-input": _vm.$v.dataSetup.type.$error } },
                [
                  _c(
                    "div",
                    { staticClass: "title-field" },
                    [
                      _c("label", [_vm._v(" Type ")]),
                      _vm._v(" "),
                      _c("jTooltipCreateView", {
                        attrs: { description: "Type Information" }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("j-single-select", {
                    attrs: {
                      options: _vm.typeFieldByType,
                      placeholder: "Select Type",
                      "value-format": "object",
                      label: "text"
                    },
                    model: {
                      value: _vm.dataSetup.type,
                      callback: function($$v) {
                        _vm.$set(_vm.dataSetup, "type", $$v)
                      },
                      expression: "dataSetup.type"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              !_vm.isSearch
                ? _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        {
                          attrs: {
                            md: _vm.isHaveConfig || _vm.isDataset ? "12" : "6"
                          }
                        },
                        [
                          _c(
                            "b-form",
                            {
                              class: {
                                "error-input": _vm.$v.dataSetup.key.$error
                              }
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "title-field" },
                                [
                                  _c("label", [_vm._v(" Key ")]),
                                  _vm._v(" "),
                                  _c("jTooltipCreateView", {
                                    attrs: { description: "Key Information" }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("j-input", {
                                attrs: { placeholder: "Enter key" },
                                model: {
                                  value: _vm.dataSetup.key,
                                  callback: function($$v) {
                                    _vm.$set(_vm.dataSetup, "key", $$v)
                                  },
                                  expression: "dataSetup.key"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      !_vm.isDataset
                        ? _c(
                            "b-col",
                            { attrs: { md: _vm.isHaveConfig ? "4" : "2" } },
                            [
                              _c(
                                "b-form",
                                {
                                  class: {
                                    "error-input":
                                      _vm.$v.dataSetup.isDisable.$error
                                  }
                                },
                                [
                                  _c("label", [_vm._v(" Disable ")]),
                                  _vm._v(" "),
                                  _c("j-toggle", {
                                    model: {
                                      value: _vm.dataSetup.isDisable,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.dataSetup,
                                          "isDisable",
                                          $$v
                                        )
                                      },
                                      expression: "dataSetup.isDisable"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.isDataset
                        ? _c(
                            "b-col",
                            { attrs: { md: _vm.isHaveConfig ? "4" : "2" } },
                            [
                              _c(
                                "b-form",
                                {
                                  class: {
                                    "error-input":
                                      _vm.$v.dataSetup.isMandatory.$error
                                  }
                                },
                                [
                                  _c("label", [_vm._v(" Mandatory ")]),
                                  _vm._v(" "),
                                  _c("j-toggle", {
                                    model: {
                                      value: _vm.dataSetup.isMandatory,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.dataSetup,
                                          "isMandatory",
                                          $$v
                                        )
                                      },
                                      expression: "dataSetup.isMandatory"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.isDataset
                        ? _c(
                            "b-col",
                            { attrs: { md: _vm.isHaveConfig ? "4" : "2" } },
                            [
                              _c(
                                "b-form",
                                {
                                  class: {
                                    "error-input":
                                      _vm.$v.dataSetup.isHidden.$error
                                  }
                                },
                                [
                                  _c("label", [_vm._v(" Hidden ")]),
                                  _vm._v(" "),
                                  _c("j-toggle", {
                                    model: {
                                      value: _vm.dataSetup.isHidden,
                                      callback: function($$v) {
                                        _vm.$set(_vm.dataSetup, "isHidden", $$v)
                                      },
                                      expression: "dataSetup.isHidden"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "b-form",
                { class: { "error-input": _vm.$v.dataSetup.name.$error } },
                [
                  _c(
                    "div",
                    { staticClass: "title-field" },
                    [
                      _c("label", [_vm._v(" Name ")]),
                      _vm._v(" "),
                      _c("jTooltipCreateView", {
                        attrs: { description: "Name Information" }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("j-input", {
                    attrs: { placeholder: "Enter field name" },
                    model: {
                      value: _vm.dataSetup.name,
                      callback: function($$v) {
                        _vm.$set(_vm.dataSetup, "name", $$v)
                      },
                      expression: "dataSetup.name"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              !_vm.isSearch
                ? _c(
                    "b-form",
                    {
                      class: {
                        "error-input": _vm.$v.dataSetup.placeholder.$error
                      }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "title-field" },
                        [
                          _c("label", [_vm._v(" Placeholder ")]),
                          _vm._v(" "),
                          _c("jTooltipCreateView", {
                            attrs: { description: "Placeholder Information" }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("j-input", {
                        attrs: { placeholder: "Enter field placeholder" },
                        model: {
                          value: _vm.dataSetup.placeholder,
                          callback: function($$v) {
                            _vm.$set(_vm.dataSetup, "placeholder", $$v)
                          },
                          expression: "dataSetup.placeholder"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.isSearch
                ? _c(
                    "b-form",
                    { class: { "error-input": _vm.$v.dataSetup.grid.$error } },
                    [
                      _c(
                        "div",
                        { staticClass: "title-field" },
                        [
                          _c("label", [_vm._v(" Grid ")]),
                          _vm._v(" "),
                          _c("jTooltipCreateView", {
                            attrs: { description: "Grid Information" }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("j-single-select", {
                        attrs: {
                          options: _vm.listGrid,
                          placeholder: "Select Grid",
                          disabled: _vm.isNoGrid,
                          label: "text"
                        },
                        model: {
                          value: _vm.dataSetup.grid,
                          callback: function($$v) {
                            _vm.$set(_vm.dataSetup, "grid", $$v)
                          },
                          expression: "dataSetup.grid"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.isSearch &&
              !_vm.isDataset &&
              (_vm.dataSetup.type.id === "text" ||
                _vm.dataSetup.type.id === "descriptive" ||
                _vm.dataSetup.type.id === "number" ||
                _vm.dataSetup.type.id === "number_decimal" ||
                _vm.dataSetup.type.id === "date" ||
                _vm.dataSetup.type.id === "time" ||
                _vm.dataSetup.type.id === "date_time" ||
                _vm.dataSetup.type.id === "currency" ||
                _vm.dataSetup.type.id === "single_selection")
                ? _c(
                    "b-form",
                    {
                      class: {
                        "error-input": _vm.$v.dataSetup.defaultValue.$error
                      }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "title-field" },
                        [
                          _c("label", [_vm._v(" Default Value ")]),
                          _vm._v(" "),
                          _c("jTooltipCreateView", {
                            attrs: { description: "Default Value Information" }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.dataSetup.type.id === "text" ||
                      _vm.dataSetup.type.id === "descriptive" ||
                      _vm.dataSetup.type.id === "single_selection"
                        ? _c("j-input", {
                            attrs: { placeholder: "Enter Default Value" },
                            model: {
                              value: _vm.dataSetup.defaultValue,
                              callback: function($$v) {
                                _vm.$set(_vm.dataSetup, "defaultValue", $$v)
                              },
                              expression: "dataSetup.defaultValue"
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.dataSetup.type.id === "number" ||
                      _vm.dataSetup.type.id === "number_decimal"
                        ? _c("j-input", {
                            attrs: {
                              placeholder: "Enter Default Value",
                              type: "number"
                            },
                            model: {
                              value: _vm.dataSetup.defaultValue,
                              callback: function($$v) {
                                _vm.$set(_vm.dataSetup, "defaultValue", $$v)
                              },
                              expression: "dataSetup.defaultValue"
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.dataSetup.type.id === "date"
                        ? _c("j-date-time", {
                            staticClass: "m__b--25",
                            attrs: {
                              type: "date",
                              data: _vm.dataSetup.defaultValue,
                              placeholder: "Enter Default Value"
                            },
                            on: {
                              getTimestamp: function($event) {
                                _vm.setValueDateAndAtime(
                                  $event,
                                  _vm.dataSetup.defaultValue
                                )
                              }
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.dataSetup.type.id === "time"
                        ? _c("j-clockpicker", {
                            attrs: {
                              data: _vm.dataSetup.defaultValue,
                              placeholder: "Enter Default Value"
                            },
                            on: {
                              input: function($event) {
                                _vm.setValueDateAndAtime(
                                  $event,
                                  _vm.dataSetup.defaultValue
                                )
                              }
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.dataSetup.type.id === "date_time"
                        ? _c("j-date-time", {
                            staticClass: "m__b--25",
                            attrs: {
                              type: "datetime",
                              data: _vm.dataSetup.defaultValue,
                              placeholder: "Enter Default Value"
                            },
                            on: {
                              getTimestamp: function($event) {
                                _vm.setValueDateAndAtime(
                                  $event,
                                  _vm.dataSetup.defaultValue
                                )
                              }
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.dataSetup.type.id === "currency"
                        ? _c("j-currency", {
                            attrs: {
                              options: _vm.exampleOptionCurrency,
                              input_mode: true,
                              placeholder: "Enter Default Value"
                            },
                            model: {
                              value: _vm.dataSetup.defaultValue,
                              callback: function($$v) {
                                _vm.$set(_vm.dataSetup, "defaultValue", $$v)
                              },
                              expression: "dataSetup.defaultValue"
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.dataSetup.type &&
                        _vm.dataSetup.type.id !== "separator" &&
                          _vm.dataSetup.type.id !== "custom_html",
                      expression:
                        "dataSetup.type && (dataSetup.type.id !== 'separator' && dataSetup.type.id !== 'custom_html')"
                    }
                  ]
                },
                [
                  _c("h4", [_vm._v("Parse Value To")]),
                  _vm._v(" "),
                  _c(
                    "b-form",
                    {
                      class: { "error-input": _vm.$v.dataSetup.variable.$error }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "title-field" },
                        [
                          _c("label", [_vm._v(" Variable ")]),
                          _vm._v(" "),
                          _c("jTooltipCreateView", {
                            attrs: { description: "Variable Information" }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("j-single-select", {
                        attrs: {
                          options: _vm.variableOptionsFiltered,
                          placeholder: "Select Variable",
                          "value-format": "object",
                          label: "label"
                        },
                        model: {
                          value: _vm.dataSetup.variable,
                          callback: function($$v) {
                            _vm.$set(_vm.dataSetup, "variable", $$v)
                          },
                          expression: "dataSetup.variable"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.isHaveConfig
            ? _c("b-col", { attrs: { md: "6" } }, [
                _c("h4", [_vm._v("Config")]),
                _vm._v(" "),
                _vm.dataSetup.type.id === "location"
                  ? _c(
                      "div",
                      [
                        _c(
                          "b-form",
                          {
                            class: {
                              "error-input":
                                _vm.$v.dataSetup.locationType.$error
                            }
                          },
                          [
                            _c("label", [_vm._v(" Location Type ")]),
                            _vm._v(" "),
                            _c("j-single-select", {
                              attrs: {
                                options: _vm.listLocationType,
                                placeholder: "Select Location Type",
                                label: "text"
                              },
                              model: {
                                value: _vm.dataSetup.locationType,
                                callback: function($$v) {
                                  _vm.$set(_vm.dataSetup, "locationType", $$v)
                                },
                                expression: "dataSetup.locationType"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-form",
                          {
                            class: {
                              "error-input": _vm.$v.dataSetup.isShowMaps.$error
                            }
                          },
                          [
                            _c("label", [_vm._v(" Show Maps ")]),
                            _vm._v(" "),
                            _c("j-toggle", {
                              model: {
                                value: _vm.dataSetup.isShowMaps,
                                callback: function($$v) {
                                  _vm.$set(_vm.dataSetup, "isShowMaps", $$v)
                                },
                                expression: "dataSetup.isShowMaps"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.dataSetup.type.id === "single_selection" ||
                _vm.dataSetup.type.id === "multiple_selection" ||
                _vm.dataSetup.type.id === "photo" ||
                _vm.dataSetup.type.id === "attachment"
                  ? _c(
                      "div",
                      [
                        _c("h4", [_vm._v("Options")]),
                        _vm._v(" "),
                        _vm._l(_vm.dataSetup.options, function(
                          itemOptions,
                          index
                        ) {
                          return _c(
                            "div",
                            { key: index },
                            [
                              _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    { attrs: { md: "10" } },
                                    [
                                      _c(
                                        "b-form",
                                        {
                                          class: {
                                            "error-input":
                                              _vm.$v.dataSetup.options.$each[
                                                index
                                              ].$error
                                          }
                                        },
                                        [
                                          _c("j-input", {
                                            attrs: {
                                              placeholder: "Enter options"
                                            },
                                            model: {
                                              value:
                                                _vm.dataSetup.options[index],
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.dataSetup.options,
                                                  index,
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "dataSetup.options[index]"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "p__l--1 m__t--5",
                                      attrs: { md: "2" }
                                    },
                                    [
                                      _c("i", {
                                        staticClass:
                                          "fa fa-trash cursor-pointer",
                                        on: {
                                          click: function($event) {
                                            _vm.deleteOptions(index)
                                          }
                                        }
                                      })
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "btn-add-column m__b--15",
                            on: { click: _vm.addoptions }
                          },
                          [_vm._v("\n          + Add options\n        ")]
                        )
                      ],
                      2
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.dataSetup.type.id === "radio" ||
                _vm.dataSetup.type.id === "checkbox"
                  ? _c(
                      "div",
                      [
                        _c("h4", [_vm._v("Options")]),
                        _vm._v(" "),
                        _vm._l(_vm.dataSetup.optionsObject, function(
                          itemOptions,
                          index
                        ) {
                          return _c(
                            "div",
                            { key: index },
                            [
                              _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    { attrs: { md: "10" } },
                                    [
                                      _c(
                                        "b-form",
                                        [
                                          _c("label", [_vm._v(" Label ")]),
                                          _vm._v(" "),
                                          _c("j-input", {
                                            attrs: {
                                              placeholder: "Enter label"
                                            },
                                            model: {
                                              value:
                                                _vm.dataSetup.optionsObject[
                                                  index
                                                ].label,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.dataSetup.optionsObject[
                                                    index
                                                  ],
                                                  "label",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "dataSetup.optionsObject[index].label"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "p__l--1 m__t--5",
                                      attrs: { md: "2" }
                                    },
                                    [
                                      _c("i", {
                                        staticClass:
                                          "fa fa-trash cursor-pointer",
                                        on: {
                                          click: function($event) {
                                            _vm.deleteOptionsObject(index)
                                          }
                                        }
                                      })
                                    ]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    { attrs: { md: "10" } },
                                    [
                                      _c(
                                        "b-form",
                                        [
                                          _c("label", [_vm._v(" Value ")]),
                                          _vm._v(" "),
                                          _c("j-input", {
                                            attrs: {
                                              placeholder: "Enter value"
                                            },
                                            model: {
                                              value:
                                                _vm.dataSetup.optionsObject[
                                                  index
                                                ].value,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.dataSetup.optionsObject[
                                                    index
                                                  ],
                                                  "value",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "dataSetup.optionsObject[index].value"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "btn-add-column m__b--15",
                            on: { click: _vm.addoptionsObject }
                          },
                          [_vm._v("\n          + Add options\n        ")]
                        )
                      ],
                      2
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.dataSetup.type.id === "attachment" ||
                _vm.dataSetup.type.id === "multiple_attachment_dynamic" ||
                _vm.dataSetup.type.id === "single_attachment"
                  ? _c(
                      "div",
                      [
                        _c(
                          "b-form",
                          {
                            class: {
                              "error-input":
                                _vm.$v.dataSetup.acceptedFileType.$error
                            }
                          },
                          [
                            _c("label", [_vm._v(" Accepted File Type ")]),
                            _vm._v(" "),
                            _c("j-multi-select", {
                              attrs: {
                                options: _vm.list_accepted_file_type,
                                placeholder: "Select Accepted File Type"
                              },
                              model: {
                                value: _vm.$v.dataSetup.acceptedFileType.$model,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.$v.dataSetup.acceptedFileType,
                                    "$model",
                                    $$v
                                  )
                                },
                                expression:
                                  "$v.dataSetup.acceptedFileType.$model"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-form",
                          {
                            class: {
                              "error-input": _vm.$v.dataSetup.isUseCamera.$error
                            }
                          },
                          [
                            _c("label", [_vm._v(" Use Camera ")]),
                            _vm._v(" "),
                            _c("j-toggle", {
                              model: {
                                value: _vm.dataSetup.isUseCamera,
                                callback: function($$v) {
                                  _vm.$set(_vm.dataSetup, "isUseCamera", $$v)
                                },
                                expression: "dataSetup.isUseCamera"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.dataSetup.isUseCamera
                          ? _c(
                              "div",
                              [
                                _c(
                                  "b-form",
                                  {
                                    class: {
                                      "error-input":
                                        _vm.$v.dataSetup.sourceCamera.$error
                                    }
                                  },
                                  [
                                    _c("label", [_vm._v(" Source ")]),
                                    _vm._v(" "),
                                    _c("b-form-radio-group", {
                                      staticClass: "jFormGroup",
                                      attrs: {
                                        options: _vm.list_source_camera,
                                        stacked: true
                                      },
                                      model: {
                                        value:
                                          _vm.$v.dataSetup.sourceCamera.$model,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.$v.dataSetup.sourceCamera,
                                            "$model",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "$v.dataSetup.sourceCamera.$model"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-form",
                                  {
                                    class: {
                                      "error-input":
                                        _vm.$v.dataSetup.chooseCamera.$error
                                    }
                                  },
                                  [
                                    _c("label", [_vm._v(" Choose Camera ")]),
                                    _vm._v(" "),
                                    _c("j-single-select", {
                                      attrs: {
                                        options: _vm.list_choose_camera,
                                        placeholder: "Choose Camera"
                                      },
                                      model: {
                                        value:
                                          _vm.$v.dataSetup.chooseCamera.$model,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.$v.dataSetup.chooseCamera,
                                            "$model",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "$v.dataSetup.chooseCamera.$model"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "b-form",
                          {
                            class: {
                              "error-input":
                                _vm.$v.dataSetup.isUseWatermark.$error
                            }
                          },
                          [
                            _c("label", [_vm._v(" Use Watermark ")]),
                            _vm._v(" "),
                            _c("j-toggle", {
                              model: {
                                value: _vm.dataSetup.isUseWatermark,
                                callback: function($$v) {
                                  _vm.$set(_vm.dataSetup, "isUseWatermark", $$v)
                                },
                                expression: "dataSetup.isUseWatermark"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.dataSetup.isUseWatermark
                          ? _c(
                              "b-form",
                              {
                                class: {
                                  "error-input": _vm.$v.dataSetup.field1.$error
                                }
                              },
                              [
                                _c("label", [_vm._v(" Field 1 ")]),
                                _vm._v(" "),
                                _c("j-single-select", {
                                  attrs: {
                                    options: _vm.variableOptionsWatermark,
                                    placeholder: "Select Field",
                                    label: "label"
                                  },
                                  model: {
                                    value: _vm.dataSetup.field1,
                                    callback: function($$v) {
                                      _vm.$set(_vm.dataSetup, "field1", $$v)
                                    },
                                    expression: "dataSetup.field1"
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.dataSetup.isUseWatermark
                          ? _c(
                              "b-form",
                              {
                                class: {
                                  "error-input": _vm.$v.dataSetup.field2.$error
                                }
                              },
                              [
                                _c("label", [_vm._v(" Field 2 ")]),
                                _vm._v(" "),
                                _c("j-single-select", {
                                  attrs: {
                                    options: _vm.variableOptionsWatermark,
                                    placeholder: "Select Field",
                                    label: "label"
                                  },
                                  model: {
                                    value: _vm.dataSetup.field2,
                                    callback: function($$v) {
                                      _vm.$set(_vm.dataSetup, "field2", $$v)
                                    },
                                    expression: "dataSetup.field2"
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.dataSetup.isUseWatermark
                          ? _c(
                              "b-form",
                              {
                                class: {
                                  "error-input": _vm.$v.dataSetup.field3.$error
                                }
                              },
                              [
                                _c("label", [_vm._v(" Field 3 ")]),
                                _vm._v(" "),
                                _c("j-single-select", {
                                  attrs: {
                                    options: _vm.variableOptionsWatermark,
                                    placeholder: "Select Field",
                                    label: "label"
                                  },
                                  model: {
                                    value: _vm.dataSetup.field3,
                                    callback: function($$v) {
                                      _vm.$set(_vm.dataSetup, "field3", $$v)
                                    },
                                    expression: "dataSetup.field3"
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.dataSetup.type.id === "relation_record" ||
                _vm.dataSetup.type.id === "multiple_relation_record"
                  ? _c("div", [
                      _c(
                        "div",
                        { staticClass: "container-relation-record" },
                        [
                          _c("h4", [_vm._v("Source Data")]),
                          _vm._v(" "),
                          _c(
                            "b-form",
                            {
                              class: {
                                "error-input":
                                  _vm.$v.dataSetup.sourceData.tableGroup.$error
                              }
                            },
                            [
                              _c("label", [_vm._v(" Table Group ")]),
                              _vm._v(" "),
                              _c("j-single-select", {
                                attrs: {
                                  "error-required":
                                    _vm.$v.dataSetup.sourceData.tableGroup
                                      .$error,
                                  options: _vm.tableGroupOptions,
                                  placeholder: "Select Table Group",
                                  "value-format": "object",
                                  label: "name"
                                },
                                model: {
                                  value:
                                    _vm.$v.dataSetup.sourceData.tableGroup
                                      .$model,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.$v.dataSetup.sourceData.tableGroup,
                                      "$model",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "$v.dataSetup.sourceData.tableGroup.$model"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-form",
                            {
                              class: {
                                "error-input":
                                  _vm.$v.dataSetup.sourceData.form.$error
                              }
                            },
                            [
                              _c("label", [_vm._v(" Table ")]),
                              _vm._v(" "),
                              _c("j-single-select", {
                                attrs: {
                                  "error-required":
                                    _vm.$v.dataSetup.sourceData.form.$error,
                                  disabled: !_vm.dataSetup.sourceData
                                    .tableGroup,
                                  options: _vm.tableOptions,
                                  placeholder: "Select Table",
                                  "value-format": "object",
                                  label: "name"
                                },
                                model: {
                                  value:
                                    _vm.$v.dataSetup.sourceData.form.$model,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.$v.dataSetup.sourceData.form,
                                      "$model",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "$v.dataSetup.sourceData.form.$model"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "container-relation-record" }, [
                        _c("h4", [_vm._v("Filter")]),
                        _vm._v(" "),
                        _c("div", { staticClass: "d-flex m__b--20" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "tab-filter m__r--15 p__l--10 p__r--10",
                              class: {
                                "tab-filter-active": _vm.tabSelected === "value"
                              },
                              on: {
                                click: function($event) {
                                  _vm.tabSelected = "value"
                                }
                              }
                            },
                            [_vm._v("\n              VALUE\n            ")]
                          ),
                          _vm._v(" "),
                          !_vm.isBulk
                            ? _c(
                                "div",
                                {
                                  staticClass: "tab-filter p__l--10 p__r--10",
                                  class: {
                                    "tab-filter-active":
                                      _vm.tabSelected === "column"
                                  },
                                  on: {
                                    click: function($event) {
                                      _vm.tabSelected = "column"
                                    }
                                  }
                                },
                                [_vm._v("\n              COLUMN\n            ")]
                              )
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _vm.tabSelected === "value"
                          ? _c(
                              "div",
                              [
                                _vm._l(_vm.dataSetup.filter, function(
                                  data,
                                  index
                                ) {
                                  return _c(
                                    "b-row",
                                    {
                                      key: index,
                                      staticClass: "filter-container w--100"
                                    },
                                    [
                                      _c(
                                        "b-col",
                                        { attrs: { cols: "11" } },
                                        [
                                          _c(
                                            "b-form",
                                            { staticClass: "mb-2" },
                                            [
                                              _c("label", [_vm._v(" Key ")]),
                                              _vm._v(" "),
                                              _c("j-single-select", {
                                                attrs: {
                                                  "error-required": false,
                                                  options: _vm.list_field_class,
                                                  placeholder: "Filter by",
                                                  "value-format": "object",
                                                  label: "label"
                                                },
                                                model: {
                                                  value: data.key,
                                                  callback: function($$v) {
                                                    _vm.$set(data, "key", $$v)
                                                  },
                                                  expression: "data.key"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-form",
                                            { staticClass: "mb-3" },
                                            [
                                              _c("label", [_vm._v(" Value ")]),
                                              _vm._v(" "),
                                              _c("j-input", {
                                                attrs: {
                                                  "error-required": false,
                                                  placeholder: "Enter value"
                                                },
                                                model: {
                                                  value: data.value,
                                                  callback: function($$v) {
                                                    _vm.$set(data, "value", $$v)
                                                  },
                                                  expression: "data.value"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-col",
                                        {
                                          staticClass:
                                            "d-flex align-items-start justify-content-center mt-2 pl-0 cursor-pointer",
                                          attrs: { cols: "1" }
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "fa fa-trash",
                                            on: {
                                              click: function($event) {
                                                _vm.deleteFilter(index)
                                              }
                                            }
                                          })
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "btn-add-column",
                                    on: { click: _vm.addFilter }
                                  },
                                  [
                                    _vm._v(
                                      "\n              + Add parameter\n            "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-form",
                                  [
                                    _c("label", [_vm._v(" Filter Operator ")]),
                                    _vm._v(" "),
                                    _c("j-single-select", {
                                      attrs: {
                                        "error-required": false,
                                        options: _vm.filterOperatorOptions,
                                        placeholder: "Filter Operator",
                                        label: "name"
                                      },
                                      model: {
                                        value: _vm.dataSetup.filterOperator,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.dataSetup,
                                            "filterOperator",
                                            $$v
                                          )
                                        },
                                        expression: "dataSetup.filterOperator"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              2
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.tabSelected === "column"
                          ? _c(
                              "div",
                              [
                                _c(
                                  "b-form",
                                  {
                                    class: {
                                      "error-input":
                                        _vm.$v.dataSetup.isWithParam.$error
                                    }
                                  },
                                  [
                                    _c("label", [_vm._v(" With Parameter ")]),
                                    _vm._v(" "),
                                    _c("j-toggle", {
                                      model: {
                                        value: _vm.dataSetup.isWithParam,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.dataSetup,
                                            "isWithParam",
                                            $$v
                                          )
                                        },
                                        expression: "dataSetup.isWithParam"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-row",
                                  [
                                    _c(
                                      "b-col",
                                      { attrs: { cols: "12" } },
                                      [
                                        _c(
                                          "b-form",
                                          {
                                            staticClass: "mb-2",
                                            class: {
                                              "error-input":
                                                _vm.$v.dataSetup.filterColumn
                                                  .$error
                                            }
                                          },
                                          [
                                            _c("label", [_vm._v(" Column ")]),
                                            _vm._v(" "),
                                            _c("j-single-select", {
                                              attrs: {
                                                "error-required":
                                                  _vm.$v.dataSetup.filterColumn
                                                    .$model,
                                                options: _vm.list_field_class,
                                                label: "label",
                                                placeholder: "Select Column"
                                              },
                                              model: {
                                                value:
                                                  _vm.$v.dataSetup.filterColumn
                                                    .$model,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.$v.dataSetup
                                                      .filterColumn,
                                                    "$model",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "$v.dataSetup.filterColumn.$model"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "b-form",
                                          {
                                            staticClass: "mb-2",
                                            class: {
                                              "error-input":
                                                _vm.$v.dataSetup.fieldKey.$error
                                            }
                                          },
                                          [
                                            _c("label", [_vm._v(" Field ")]),
                                            _vm._v(" "),
                                            _c("j-single-select", {
                                              attrs: {
                                                "error-required":
                                                  _vm.$v.dataSetup.fieldKey
                                                    .$model,
                                                options: _vm.list_field_key,
                                                label: "name",
                                                placeholder: "Select Field"
                                              },
                                              model: {
                                                value:
                                                  _vm.$v.dataSetup.fieldKey
                                                    .$model,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.$v.dataSetup.fieldKey,
                                                    "$model",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "$v.dataSetup.fieldKey.$model"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "container-relation-record" },
                        [
                          _c("h4", [_vm._v("Sorting")]),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                { attrs: { cols: "12" } },
                                [
                                  _c(
                                    "b-form",
                                    {
                                      staticClass: "mb-2",
                                      class: {
                                        "error-input":
                                          _vm.$v.dataSetup.sorting.key.$error
                                      }
                                    },
                                    [
                                      _c("label", [_vm._v(" Sort By ")]),
                                      _vm._v(" "),
                                      _c("j-single-select", {
                                        attrs: {
                                          "error-required": false,
                                          options: _vm.list_field_class,
                                          placeholder: "Sort by",
                                          "value-format": "object",
                                          label: "label"
                                        },
                                        model: {
                                          value: _vm.dataSetup.sorting.key,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.dataSetup.sorting,
                                              "key",
                                              $$v
                                            )
                                          },
                                          expression: "dataSetup.sorting.key"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                { attrs: { cols: "12" } },
                                [
                                  _c(
                                    "b-form",
                                    {
                                      staticClass: "mb-3",
                                      class: {
                                        "error-input":
                                          _vm.$v.dataSetup.sorting.order.$error
                                      }
                                    },
                                    [
                                      _c("label", [_vm._v(" Order By ")]),
                                      _vm._v(" "),
                                      _c("j-single-select", {
                                        attrs: {
                                          "error-required": false,
                                          options: _vm.orderOptions,
                                          placeholder: "Order by",
                                          "value-format": "object",
                                          label: "label"
                                        },
                                        model: {
                                          value: _vm.dataSetup.sorting.order,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.dataSetup.sorting,
                                              "order",
                                              $$v
                                            )
                                          },
                                          expression: "dataSetup.sorting.order"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.dataSetup.type.id === "relation_record" &&
                      !_vm.isBulk &&
                      !_vm.isSearch
                        ? _c(
                            "div",
                            { staticClass: "container-relation-record" },
                            [
                              _c(
                                "b-row",
                                [
                                  _c("b-col", { attrs: { md: "6" } }, [
                                    _c("h4", [_vm._v(" Auto Fill ")])
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "b-col",
                                    {
                                      staticStyle: { "padding-left": "30%" },
                                      attrs: { md: "6" }
                                    },
                                    [
                                      _c("j-toggle", {
                                        model: {
                                          value: _vm.dataSetup.isAutoFill,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.dataSetup,
                                              "isAutoFill",
                                              $$v
                                            )
                                          },
                                          expression: "dataSetup.isAutoFill"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.list_field.length > 0 &&
                              _vm.dataSetup.isAutoFill
                                ? _c(
                                    "div",
                                    [
                                      _c("h4", [_vm._v("List Field")]),
                                      _vm._v(" "),
                                      _c(
                                        "draggable",
                                        {
                                          model: {
                                            value: _vm.dataSetup.fieldGroup,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.dataSetup,
                                                "fieldGroup",
                                                $$v
                                              )
                                            },
                                            expression: "dataSetup.fieldGroup"
                                          }
                                        },
                                        [
                                          _c(
                                            "transition-group",
                                            { staticClass: "row" },
                                            _vm._l(
                                              _vm.dataSetup.fieldGroup,
                                              function(data, index) {
                                                return _c(
                                                  "div",
                                                  {
                                                    key: index,
                                                    staticClass: "col-md-12"
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "list-column-field"
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "col-one"
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "label--name ellipsis"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    data.name
                                                                  )
                                                                )
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "ellipsis"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    data.type
                                                                  )
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "col-two"
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "ellipsis"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "UI Key : " +
                                                                    _vm._s(
                                                                      data.field_ui_key
                                                                    )
                                                                )
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "ellipsis"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "Data Key : " +
                                                                    _vm._s(
                                                                      data.field_data_key
                                                                    )
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "col-three"
                                                          },
                                                          [
                                                            _c("i", {
                                                              staticClass:
                                                                "fa fa-lg fa-trash pull-right cursor-pointer m__r--5 m__t--5",
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  _vm.deleteField(
                                                                    index
                                                                  )
                                                                }
                                                              }
                                                            }),
                                                            _vm._v(" "),
                                                            _c("i", {
                                                              staticClass:
                                                                "fa fa-lg fa-pencil pull-right cursor-pointer m__r--5 m__t--5",
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  _vm.openModalEditField(
                                                                    data,
                                                                    index
                                                                  )
                                                                }
                                                              }
                                                            })
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              }
                                            )
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "btn-add-column",
                                          attrs: { id: "fieldGroupAdd" },
                                          on: {
                                            click: function($event) {
                                              _vm.openModalEditField(null, 0)
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n              + Add field\n            "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-popover",
                                        {
                                          ref: "popoverFieldGroup",
                                          attrs: {
                                            target: "fieldGroupAdd",
                                            container: "container-external-api",
                                            placement: "auto"
                                          }
                                        },
                                        [
                                          _vm.isOpen
                                            ? _c("j-column-edit-fill", {
                                                attrs: {
                                                  "field-detail":
                                                    _vm.selectedField,
                                                  "variable-options":
                                                    _vm.list_field,
                                                  type: _vm.dataSetup.type.id,
                                                  "is-external": false
                                                },
                                                on: {
                                                  "close-modal":
                                                    _vm.closeModalEditField,
                                                  "submit-mode": _vm.submitField
                                                }
                                              })
                                            : _vm._e(),
                                          _c("br"),
                                          _c("br")
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "container-relation-record" },
                        [
                          _c("h4", [_vm._v("Configuration")]),
                          _vm._v(" "),
                          _c(
                            "b-form",
                            {
                              class: {
                                "error-input":
                                  _vm.$v.dataSetup.sourceData.setValue.$error
                              }
                            },
                            [
                              _c("label", [_vm._v(" Set Value Selected ")]),
                              _vm._v(" "),
                              _c("j-single-select", {
                                attrs: {
                                  options: _vm.list_field,
                                  label: "name",
                                  placeholder: "Select Variable"
                                },
                                model: {
                                  value:
                                    _vm.$v.dataSetup.sourceData.setValue.$model,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.$v.dataSetup.sourceData.setValue,
                                      "$model",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "$v.dataSetup.sourceData.setValue.$model"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-form",
                            {
                              class: {
                                "error-input":
                                  _vm.$v.dataSetup.sourceData.showData.$error
                              }
                            },
                            [
                              _c("label", [_vm._v(" Show Data Option ")]),
                              _vm._v(" "),
                              _c("j-single-select", {
                                attrs: {
                                  options: _vm.list_field,
                                  label: "name",
                                  placeholder: "Select Variable"
                                },
                                model: {
                                  value:
                                    _vm.$v.dataSetup.sourceData.showData.$model,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.$v.dataSetup.sourceData.showData,
                                      "$model",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "$v.dataSetup.sourceData.showData.$model"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-form",
                            {
                              class: {
                                "error-input":
                                  _vm.$v.dataSetup.sourceData.searchData.$error
                              }
                            },
                            [
                              _c("label", [_vm._v(" Search Data Option ")]),
                              _vm._v(" "),
                              _c("j-single-select", {
                                attrs: {
                                  options: _vm.list_field,
                                  label: "name",
                                  placeholder: "Select Variable"
                                },
                                model: {
                                  value:
                                    _vm.$v.dataSetup.sourceData.searchData
                                      .$model,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.$v.dataSetup.sourceData.searchData,
                                      "$model",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "$v.dataSetup.sourceData.searchData.$model"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                { attrs: { md: "6" } },
                                [
                                  _c(
                                    "b-form",
                                    {
                                      class: {
                                        "error-input":
                                          _vm.$v.dataSetup.isAutoShow.$error
                                      }
                                    },
                                    [
                                      _c("label", [_vm._v(" Auto Show ")]),
                                      _vm._v(" "),
                                      _c("j-toggle", {
                                        model: {
                                          value: _vm.dataSetup.isAutoShow,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.dataSetup,
                                              "isAutoShow",
                                              $$v
                                            )
                                          },
                                          expression: "dataSetup.isAutoShow"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                { attrs: { md: "6" } },
                                [
                                  _vm.dataSetup.type.id ===
                                  "multiple_relation_record"
                                    ? _c(
                                        "b-form",
                                        [
                                          _c("label", [
                                            _vm._v(" Allow Select All  Data ")
                                          ]),
                                          _vm._v(" "),
                                          _c("j-toggle", {
                                            model: {
                                              value:
                                                _vm.dataSetup
                                                  .isAllowSelectAllData,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.dataSetup,
                                                  "isAllowSelectAllData",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "dataSetup.isAllowSelectAllData"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.dataSetup.type.id === "relation_record" &&
                      !_vm.isBulk &&
                      !_vm.isSearch &&
                      !_vm.isDataset
                        ? _c(
                            "div",
                            { staticClass: "container-config__item" },
                            [
                              _c(
                                "b-form",
                                {
                                  class: {
                                    "error-input":
                                      _vm.$v.dataSetup.isValueChange.$error
                                  }
                                },
                                [
                                  _c(
                                    "b-row",
                                    [
                                      _c("b-col", { attrs: { md: 10 } }, [
                                        _c(
                                          "div",
                                          { staticClass: "title-field" },
                                          [
                                            _c("label", [
                                              _vm._v(" On Value Change ")
                                            ]),
                                            _vm._v(" "),
                                            _c("jTooltipCreateView", {
                                              attrs: {
                                                description:
                                                  "On Value Change Information"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "b-col",
                                        { attrs: { md: 2 } },
                                        [
                                          _c("j-toggle", {
                                            model: {
                                              value:
                                                _vm.dataSetup.isValueChange,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.dataSetup,
                                                  "isValueChange",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "dataSetup.isValueChange"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.useEditorCode
                                ? _c(
                                    "b-form",
                                    {
                                      class: {
                                        "error-input":
                                          _vm.$v.dataSetup.onValueChange.$error
                                      }
                                    },
                                    [
                                      _c("label", [_vm._v(" Script ")]),
                                      _vm._v(" "),
                                      _vm.openEditor
                                        ? _c("j-monaco-editor", {
                                            ref: "scriptEditor",
                                            attrs: {
                                              value: _vm.dataSetup.onValueChange
                                            }
                                          })
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        : _vm._e()
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.dataSetup.type.id === "relation_record_external_api" ||
                _vm.dataSetup.type.id ===
                  "multiple_relation_record_external_api"
                  ? _c(
                      "div",
                      [
                        _c(
                          "div",
                          { staticClass: "container-relation-record" },
                          [
                            _c("h4", [_vm._v("Source Data")]),
                            _vm._v(" "),
                            _c("div", { staticClass: "external-ui" }, [
                              _vm._v("\n            External API "),
                              _c("br"),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticClass: "font-blue cursor-pointer",
                                  attrs: { id: "externalApiAdd" }
                                },
                                [_vm._v("\n              Config\n            ")]
                              )
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "container-relation-record" },
                          [
                            _c("h4", [_vm._v("Configuration")]),
                            _vm._v(" "),
                            _c(
                              "b-form",
                              {
                                class: {
                                  "error-input":
                                    _vm.$v.dataSetup.sourceExternalVariable
                                      .$error
                                }
                              },
                              [
                                _c("label", [_vm._v(" Show Data Option ")]),
                                _vm._v(" "),
                                _c("j-input", {
                                  attrs: { placeholder: "Enter variable" },
                                  model: {
                                    value: _vm.dataSetup.sourceExternalVariable,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.dataSetup,
                                        "sourceExternalVariable",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "dataSetup.sourceExternalVariable"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-form",
                              {
                                class: {
                                  "error-input":
                                    _vm.$v.dataSetup.sourceExternalSetValue
                                      .$error
                                }
                              },
                              [
                                _c("label", [_vm._v(" Set Value Selected ")]),
                                _vm._v(" "),
                                _c("j-single-select", {
                                  attrs: {
                                    options: _vm.list_field_external,
                                    placeholder: "Select Variable"
                                  },
                                  model: {
                                    value:
                                      _vm.$v.dataSetup.sourceExternalSetValue
                                        .$model,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.$v.dataSetup.sourceExternalSetValue,
                                        "$model",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "$v.dataSetup.sourceExternalSetValue.$model"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-row",
                              [
                                _c(
                                  "b-col",
                                  { attrs: { md: "6" } },
                                  [
                                    _c(
                                      "b-form",
                                      {
                                        class: {
                                          "error-input":
                                            _vm.$v.dataSetup.isAutoShow.$error
                                        }
                                      },
                                      [
                                        _c("label", [_vm._v(" Auto Show ")]),
                                        _vm._v(" "),
                                        _c("j-toggle", {
                                          model: {
                                            value: _vm.dataSetup.isAutoShow,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.dataSetup,
                                                "isAutoShow",
                                                $$v
                                              )
                                            },
                                            expression: "dataSetup.isAutoShow"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-col",
                                  { attrs: { md: "6" } },
                                  [
                                    _vm.dataSetup.type.id ===
                                    "multiple_relation_record_external_api"
                                      ? _c(
                                          "b-form",
                                          [
                                            _c("label", [
                                              _vm._v(" Allow Select All  Data ")
                                            ]),
                                            _vm._v(" "),
                                            _c("j-toggle", {
                                              model: {
                                                value:
                                                  _vm.dataSetup
                                                    .isAllowSelectAllData,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.dataSetup,
                                                    "isAllowSelectAllData",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "dataSetup.isAllowSelectAllData"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      : _vm._e()
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.dataSetup.type.id ===
                          "relation_record_external_api" &&
                        !_vm.isBulk &&
                        !_vm.isSearch
                          ? _c(
                              "div",
                              { staticClass: "container-relation-record" },
                              [
                                _c(
                                  "b-row",
                                  [
                                    _c("b-col", { attrs: { md: "6" } }, [
                                      _c("h4", [_vm._v(" Auto Fill ")])
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "b-col",
                                      {
                                        staticStyle: { "padding-left": "30%" },
                                        attrs: { md: "6" }
                                      },
                                      [
                                        _c("j-toggle", {
                                          model: {
                                            value: _vm.dataSetup.isAutoFill,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.dataSetup,
                                                "isAutoFill",
                                                $$v
                                              )
                                            },
                                            expression: "dataSetup.isAutoFill"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _vm.dataSetup.isAutoFill
                                  ? _c(
                                      "div",
                                      [
                                        _c("h4", [_vm._v("List Field")]),
                                        _vm._v(" "),
                                        _c(
                                          "draggable",
                                          {
                                            model: {
                                              value: _vm.dataSetup.fieldGroup,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.dataSetup,
                                                  "fieldGroup",
                                                  $$v
                                                )
                                              },
                                              expression: "dataSetup.fieldGroup"
                                            }
                                          },
                                          [
                                            _c(
                                              "transition-group",
                                              { staticClass: "row" },
                                              _vm._l(
                                                _vm.dataSetup.fieldGroup,
                                                function(data, index) {
                                                  return _c(
                                                    "div",
                                                    {
                                                      key: index,
                                                      staticClass: "col-md-12"
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "list-column-field"
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "col-one"
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "label--name ellipsis"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      data.name
                                                                    )
                                                                  )
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "ellipsis"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      data.type
                                                                    )
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "col-two"
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "ellipsis"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "UI Key : " +
                                                                      _vm._s(
                                                                        data.field_ui_key
                                                                      )
                                                                  )
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "ellipsis"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "Data Key : " +
                                                                      _vm._s(
                                                                        data.field_data_key
                                                                      )
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "col-three"
                                                            },
                                                            [
                                                              _c("i", {
                                                                staticClass:
                                                                  "fa fa-lg fa-trash pull-right cursor-pointer m__r--5 m__t--5",
                                                                on: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    _vm.deleteField(
                                                                      index
                                                                    )
                                                                  }
                                                                }
                                                              }),
                                                              _vm._v(" "),
                                                              _c("i", {
                                                                staticClass:
                                                                  "fa fa-lg fa-pencil pull-right cursor-pointer m__r--5 m__t--5",
                                                                on: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    _vm.openModalEditField(
                                                                      data,
                                                                      index
                                                                    )
                                                                  }
                                                                }
                                                              })
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                }
                                              )
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "btn-add-column",
                                            attrs: { id: "fieldGroupAdd" },
                                            on: {
                                              click: function($event) {
                                                _vm.openModalEditField(null, 0)
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n              + Add field\n            "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "b-popover",
                                          {
                                            ref: "popoverFieldGroup",
                                            attrs: {
                                              target: "fieldGroupAdd",
                                              container:
                                                "container-external-api",
                                              placement: "auto"
                                            }
                                          },
                                          [
                                            _vm.isOpen
                                              ? _c("j-column-edit-fill", {
                                                  attrs: {
                                                    "field-detail":
                                                      _vm.selectedField,
                                                    "variable-options":
                                                      _vm.list_field,
                                                    type: _vm.dataSetup.type.id,
                                                    "is-external": true
                                                  },
                                                  on: {
                                                    "close-modal":
                                                      _vm.closeModalEditField,
                                                    "submit-mode":
                                                      _vm.submitField
                                                  }
                                                })
                                              : _vm._e(),
                                            _c("br"),
                                            _c("br")
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.dataSetup.type.id ===
                          "relation_record_external_api" &&
                        !_vm.isBulk &&
                        !_vm.isSearch
                          ? _c(
                              "div",
                              { staticClass: "container-config__item" },
                              [
                                _c(
                                  "b-form",
                                  {
                                    class: {
                                      "error-input":
                                        _vm.$v.dataSetup.isValueChange.$error
                                    }
                                  },
                                  [
                                    _c(
                                      "b-row",
                                      [
                                        _c("b-col", { attrs: { md: 10 } }, [
                                          _c(
                                            "div",
                                            { staticClass: "title-field" },
                                            [
                                              _c("label", [
                                                _vm._v(" On Value Change ")
                                              ]),
                                              _vm._v(" "),
                                              _c("jTooltipCreateView", {
                                                attrs: {
                                                  description:
                                                    "On Value Change Information"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "b-col",
                                          { attrs: { md: 2 } },
                                          [
                                            _c("j-toggle", {
                                              model: {
                                                value:
                                                  _vm.dataSetup.isValueChange,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.dataSetup,
                                                    "isValueChange",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "dataSetup.isValueChange"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _vm.useEditorCode
                                  ? _c(
                                      "b-form",
                                      {
                                        class: {
                                          "error-input":
                                            _vm.$v.dataSetup.onValueChange
                                              .$error
                                        }
                                      },
                                      [
                                        _c("label", [_vm._v(" Script ")]),
                                        _vm._v(" "),
                                        _vm.openEditor
                                          ? _c("j-monaco-editor", {
                                              ref: "scriptEditor",
                                              attrs: {
                                                value:
                                                  _vm.dataSetup.onValueChange
                                              }
                                            })
                                          : _vm._e()
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "b-popover",
                          {
                            ref: "popoverExternalApi",
                            attrs: {
                              show: _vm.popoverExternalApiShow,
                              target: "externalApiAdd",
                              container: "container-external-api",
                              triggers: "click",
                              placement: "left"
                            },
                            on: {
                              "update:show": function($event) {
                                _vm.popoverExternalApiShow = $event
                              }
                            }
                          },
                          [
                            _c("j-external-api-field", {
                              attrs: {
                                "data-edit": _vm.dataSetup.sourceExternal
                              },
                              on: {
                                "submit-data": _vm.submitExternalUrl,
                                "close-modal": _vm.closeModalExternalUrl
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                (_vm.dataSetup.type.id === "group" ||
                  _vm.dataSetup.type.id === "table_group") &&
                _vm.variableOptionsGroup.length > 0
                  ? _c(
                      "div",
                      [
                        _c(
                          "div",
                          { staticClass: "container-group-table-group" },
                          [
                            _c("h4", [_vm._v("Field Group")]),
                            _vm._v(" "),
                            _c(
                              "draggable",
                              {
                                model: {
                                  value: _vm.dataSetup.fieldGroup,
                                  callback: function($$v) {
                                    _vm.$set(_vm.dataSetup, "fieldGroup", $$v)
                                  },
                                  expression: "dataSetup.fieldGroup"
                                }
                              },
                              [
                                _c(
                                  "transition-group",
                                  { staticClass: "row" },
                                  _vm._l(_vm.dataSetup.fieldGroup, function(
                                    data,
                                    index
                                  ) {
                                    return _c(
                                      "div",
                                      { key: index, staticClass: "col-md-12" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "list-column-field" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "col-one" },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "label--name ellipsis"
                                                  },
                                                  [_vm._v(_vm._s(data.name))]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  { staticClass: "ellipsis" },
                                                  [_vm._v(_vm._s(data.type))]
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "col-two" },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "ellipsis" },
                                                  [
                                                    _vm._v(
                                                      "UI Key : " +
                                                        _vm._s(
                                                          data.field_ui_key
                                                        )
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  { staticClass: "ellipsis" },
                                                  [
                                                    _vm._v(
                                                      "Data Key : " +
                                                        _vm._s(
                                                          data.field_data_key
                                                        )
                                                    )
                                                  ]
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "col-three" },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "fa fa-lg fa-trash pull-right cursor-pointer m__r--5 m__t--5",
                                                  on: {
                                                    click: function($event) {
                                                      _vm.deleteField(index)
                                                    }
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c("i", {
                                                  staticClass:
                                                    "fa fa-lg fa-pencil pull-right cursor-pointer m__r--5 m__t--5",
                                                  on: {
                                                    click: function($event) {
                                                      _vm.openModalEditField(
                                                        data,
                                                        index
                                                      )
                                                    }
                                                  }
                                                })
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  })
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "btn-add-column",
                                attrs: { id: "fieldGroupAdd" },
                                on: {
                                  click: function($event) {
                                    _vm.openModalEditField(null, 0)
                                  }
                                }
                              },
                              [_vm._v("\n            + Add field\n          ")]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "container-group-table-group" },
                          [
                            _c("h4", [_vm._v("Disable Buttons")]),
                            _vm._v(" "),
                            _c(
                              "b-row",
                              [
                                _c(
                                  "b-col",
                                  { attrs: { md: 4 } },
                                  [
                                    _c(
                                      "b-form",
                                      {
                                        class: {
                                          "error-input":
                                            _vm.$v.dataSetup.isDisableAddMore
                                              .$error
                                        }
                                      },
                                      [
                                        _c("label", [_vm._v(" Add More ")]),
                                        _vm._v(" "),
                                        _c("j-toggle", {
                                          model: {
                                            value:
                                              _vm.dataSetup.isDisableAddMore,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.dataSetup,
                                                "isDisableAddMore",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "dataSetup.isDisableAddMore"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-col",
                                  { attrs: { md: 4 } },
                                  [
                                    _c(
                                      "b-form",
                                      {
                                        class: {
                                          "error-input":
                                            _vm.$v.dataSetup.isDisableDeleteRow
                                              .$error
                                        }
                                      },
                                      [
                                        _c("label", [_vm._v(" Delete Row ")]),
                                        _vm._v(" "),
                                        _c("j-toggle", {
                                          model: {
                                            value:
                                              _vm.dataSetup.isDisableDeleteRow,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.dataSetup,
                                                "isDisableDeleteRow",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "dataSetup.isDisableDeleteRow"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-popover",
                          {
                            ref: "popoverFieldGroup",
                            attrs: {
                              target: "fieldGroupAdd",
                              container: "container-external-api",
                              placement: "auto"
                            }
                          },
                          [
                            _vm.isOpen
                              ? _c("j-column-edit-group", {
                                  attrs: {
                                    "field-detail": _vm.selectedField,
                                    "variable-options":
                                      _vm.variableOptionsGroup,
                                    "field-ui-key": _vm.dataSetup.fieldGroup,
                                    type: _vm.dataSetup.type.id,
                                    "is-external": false,
                                    "is-detail-view": _vm.isDetailView
                                  },
                                  on: {
                                    "close-modal": _vm.closeModalEditField,
                                    "submit-mode": _vm.submitField
                                  }
                                })
                              : _vm._e(),
                            _c("br"),
                            _c("br")
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.dataSetup.type.id === "single_tags_selection" ||
                _vm.dataSetup.type.id === "multiple_tags_selection"
                  ? _c(
                      "div",
                      [
                        _c("h4", { staticClass: "p__b--10" }, [
                          _vm._v("Options")
                        ]),
                        _vm._v(" "),
                        _vm._l(_vm.dataSetup.tags, function(item, index) {
                          return _c(
                            "div",
                            {
                              key: index,
                              staticClass: "container-group__item"
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "item__counter-group" },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(index + 1) +
                                      "\n          "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticClass: "item__remove cursor-pointer",
                                  on: {
                                    click: function($event) {
                                      _vm.deleteTags(index)
                                    }
                                  }
                                },
                                [_c("i", { staticClass: "fa fa-trash fa-2x" })]
                              ),
                              _vm._v(" "),
                              _c(
                                "b-form",
                                [
                                  _c("label", [_vm._v(" Name ")]),
                                  _vm._v(" "),
                                  _c("j-input", {
                                    attrs: { placeholder: "Enter tags name" },
                                    model: {
                                      value: item.name,
                                      callback: function($$v) {
                                        _vm.$set(item, "name", $$v)
                                      },
                                      expression: "item.name"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    { attrs: { md: "6" } },
                                    [
                                      _c("j-color-picker", {
                                        attrs: {
                                          color: item.background,
                                          label: "Background",
                                          picker: "chrome"
                                        },
                                        model: {
                                          value: item.background,
                                          callback: function($$v) {
                                            _vm.$set(item, "background", $$v)
                                          },
                                          expression: "item.background"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-col",
                                    { attrs: { md: "6" } },
                                    [
                                      _c("j-color-picker", {
                                        attrs: {
                                          color: item.font_color,
                                          label: "Font Color",
                                          picker: "chrome"
                                        },
                                        model: {
                                          value: item.font_color,
                                          callback: function($$v) {
                                            _vm.$set(item, "font_color", $$v)
                                          },
                                          expression: "item.font_color"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "btn-add-column m__b--15",
                            on: { click: _vm.addTags }
                          },
                          [_vm._v("\n          + Add options\n        ")]
                        )
                      ],
                      2
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.dataSetup.type.id === "custom_html"
                  ? _c(
                      "div",
                      [
                        _c("quill-editor", {
                          ref: "myQuillEditor",
                          attrs: { options: _vm.editorOption },
                          model: {
                            value: _vm.dataSetup.html,
                            callback: function($$v) {
                              _vm.$set(_vm.dataSetup, "html", $$v)
                            },
                            expression: "dataSetup.html"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.dataSetup.type.id === "date" ||
                (_vm.dataSetup.type.id === "date_time" &&
                  !_vm.isBulk &&
                  !_vm.isSearch)
                  ? _c(
                      "div",
                      [
                        _c(
                          "b-form",
                          {
                            staticClass: "container-config__item",
                            class: {
                              "error-input":
                                _vm.$v.dataSetup.isDisableBackDate.$error
                            }
                          },
                          [
                            _c(
                              "b-row",
                              [
                                _c("b-col", { attrs: { md: 10 } }, [
                                  _c(
                                    "div",
                                    { staticClass: "title-field" },
                                    [
                                      _c("label", [
                                        _vm._v(" Disable Back Date ")
                                      ]),
                                      _vm._v(" "),
                                      _c("jTooltipCreateView", {
                                        attrs: {
                                          description:
                                            "Disable Back Date Information"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ]),
                                _vm._v(" "),
                                _c(
                                  "b-col",
                                  { attrs: { md: 2 } },
                                  [
                                    _c("j-toggle", {
                                      model: {
                                        value: _vm.dataSetup.isDisableBackDate,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.dataSetup,
                                            "isDisableBackDate",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "dataSetup.isDisableBackDate"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                (_vm.dataSetup.type.id === "number" ||
                  _vm.dataSetup.type.id === "number_decimal" ||
                  _vm.dataSetup.type.id === "currency" ||
                  _vm.dataSetup.type.id === "single_selection" ||
                  _vm.dataSetup.type.id === "text" ||
                  _vm.dataSetup.type.id === "date" ||
                  _vm.dataSetup.type.id === "time" ||
                  _vm.dataSetup.type.id === "date_time" ||
                  _vm.dataSetup.type.id === "radio" ||
                  _vm.dataSetup.type.id === "checkbox" ||
                  _vm.dataSetup.type.id === "toggle" ||
                  _vm.dataSetup.type.id === "password" ||
                  _vm.dataSetup.type.id === "single_attachment") &&
                !_vm.isBulk &&
                !_vm.isSearch &&
                !_vm.isDataset
                  ? _c(
                      "div",
                      { staticClass: "container-config__item" },
                      [
                        _c(
                          "b-form",
                          {
                            class: {
                              "error-input":
                                _vm.$v.dataSetup.isValueChange.$error
                            }
                          },
                          [
                            _c(
                              "b-row",
                              [
                                _c("b-col", { attrs: { md: 10 } }, [
                                  _c(
                                    "div",
                                    { staticClass: "title-field" },
                                    [
                                      _c("label", [
                                        _vm._v(" On Value Change ")
                                      ]),
                                      _vm._v(" "),
                                      _c("jTooltipCreateView", {
                                        attrs: {
                                          description:
                                            "On Value Change Information"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ]),
                                _vm._v(" "),
                                _c(
                                  "b-col",
                                  { attrs: { md: 2 } },
                                  [
                                    _c("j-toggle", {
                                      model: {
                                        value: _vm.dataSetup.isValueChange,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.dataSetup,
                                            "isValueChange",
                                            $$v
                                          )
                                        },
                                        expression: "dataSetup.isValueChange"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.useEditorCode
                          ? _c(
                              "b-form",
                              {
                                class: {
                                  "error-input":
                                    _vm.$v.dataSetup.onValueChange.$error
                                }
                              },
                              [
                                _c("label", [_vm._v(" Script ")]),
                                _vm._v(" "),
                                _vm.openEditor
                                  ? _c("j-monaco-editor", {
                                      ref: "scriptEditor",
                                      attrs: {
                                        value: _vm.dataSetup.onValueChange
                                      }
                                    })
                                  : _vm._e()
                              ],
                              1
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.dataSetup.type.id === "code_editor"
                  ? _c(
                      "div",
                      [
                        _c(
                          "b-form",
                          {
                            class: {
                              "error-input": _vm.$v.dataSetup.language.$error
                            }
                          },
                          [
                            _c("label", [_vm._v(" Language ")]),
                            _vm._v(" "),
                            _c("j-single-select", {
                              attrs: {
                                options: _vm.languageOptions,
                                placeholder: "Select Language",
                                label: "name"
                              },
                              model: {
                                value: _vm.$v.dataSetup.language.$model,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.$v.dataSetup.language,
                                    "$model",
                                    $$v
                                  )
                                },
                                expression: "$v.dataSetup.language.$model"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e()
              ])
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "float-right m__t--10" },
        [
          _c(
            "b-button",
            { staticClass: "btn m__r--5", on: { click: _vm.closeModal } },
            [_vm._v("\n      Close\n    ")]
          ),
          _vm._v(" "),
          _c(
            "b-button",
            { staticClass: "btn blue", on: { click: _vm.submitForm } },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.fieldDetail ? "Update" : "Add") +
                  "\n    "
              )
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a0dc3d56", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a0dc3d56","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/experience-manager/menu/jColumnEdit.vue
// module id = null
// module chunks = 